// third-party
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProduct, getProject, handleAsyncCall } from 'utils/common';
import UserAccessService from 'services/userAccess';
import DnsOutlined from '@mui/icons-material/DnsOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import SupportAgentOutlined from '@mui/icons-material/SupportAgentOutlined';
import ExitToAppOutlined from '@mui/icons-material/ExitToAppOutlined';

export const completeMenuList = [
  {
    id: 'product',
    Icon: DnsOutlined,
    text: 'MAIN_MENU'
  },
  {
    id: 'project',
    Icon: DescriptionOutlined,
    text: 'CONTRACT'
  },
  {
    id: 'profile',
    Icon: PersonOutlineOutlined,
    text: 'USER_PROFILE'
  },
  {
    id: 'support',
    Icon: SupportAgentOutlined,
    text: 'SUPPORT'
  },
  { id: 'logout', Icon: ExitToAppOutlined, text: 'LOGOUT' }
];
const project = getProject();

// initial state
const initialState = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  drawerOpen: false,
  componentDrawerOpen: true,
  showDrawer: true,
  menuList: completeMenuList,
  leftMenuList: [],
  formattedLeftMenu: []
};

export const rFetchLeftMenu = createAsyncThunk('act/rFetchLeftMenu', async (params, { rejectWithValue, getState }) => {
  const productId = getState().comModule.product?.Id;
  try {
    const res = handleAsyncCall({
      service: UserAccessService.getLeftMenu,
      params: {
        prodid: productId
      },
      rejectWithValue
    });
    return res;
  } catch (err) {
    console.log(err);
  }
});
// =============================|| SLICE - MENU ||============================== //

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
    setShowDrawer(state, action) {
      state.showDrawer = action.payload;
    },
    setMenuList(state, action) {
      state.menuList = action.payload;
    },
    setLeftMenuList(state, action) {
      state.leftMenuList = action.payload;
    },

    setState: (state, action) => {
      const [key, value] = action.payload;
      state[key] = value;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(rFetchLeftMenu.fulfilled, (state, action) => {
      state.leftMenuList = action.payload;
    });
  }
});

export default menu.reducer;

export const { setState, activeItem, activeComponent, openDrawer, openComponentDrawer, setLeftMenuList, setShowDrawer, setMenuList } =
  menu.actions;
